import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/modules/authentication/authentication.service';

@Component({
  selector: 'app-session-expired',
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
})
export class SessionExpiredComponent implements OnDestroy {
  private subscription!: Subscription;

  constructor(
    private authServices: AuthenticationService,
    private router: Router,
  ) {
    this.subscription = this.authServices.activeSessionIsValid.subscribe(
      (res) => {
        if (res) {
          this.router.navigate(['/']);
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  renewSession() {
    this.authServices.renewActiveSession();
  }
}
